import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const UpdateMyProfileRequestDtoSchema = z.object({
  fullName: z.string().optional(),
  profileUrl: z.string().optional(),
});

const UpdateMyProfileResponseDtoSchema = UserDtoSchema;

export type UpdateMyProfileRequestDto = z.infer<
  typeof UpdateMyProfileRequestDtoSchema
>;
export type UpdateMyProfileResponseDto = z.infer<
  typeof UpdateMyProfileResponseDtoSchema
>;

export const updateMyProfile = async (
  dto: UpdateMyProfileRequestDto,
  config?: AxiosRequestConfig<UpdateMyProfileRequestDto>
) => {
  const data = UpdateMyProfileRequestDtoSchema.parse(dto);
  return api
    .patch('/users/me/update', data, config)
    .then(responseContract(UpdateMyProfileResponseDtoSchema));
};
